import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import axios from 'axios';

export const getSavedQuestions = createAsyncThunk('/jarvis/mock/savedQuestionsList', async () => {
  const response = await axios.post('/jarvis/mock/savedQuestionsList', {})
  return response.data.payload;
})

export const saveHighlight = createAsyncThunk('/jarvis/mock/round/saveHighlight/savedQuestions', async (obj) => {
  const response = await axios.post('/jarvis/mock/round/saveHighlight', obj)
  return { questionInfo: obj, response: response.data };
})

export const getHowToApproach = createAsyncThunk('/jarvis/mock/round/howToApproach/savedQuestions', async ({ roundId, questionId, question, type }) => {
  const response = await axios.post('/jarvis/mock/round/howToApproach', { roundId, questionId, question })
  return { questionInfo: { roundId, questionId, type }, response: response.data };
})


export const savedQuestionsSlice = createSlice({
  name: 'savedQuestions',
  initialState: {
    // list of questions
    allSavedQuestions: [],
    showGetSavedQuestionLoader: false,
    // highlight
    showHighlightLoader: false,
    // how to approach
    howToApproachContent: '',
    showHowToApproachLoader: false
  },
  reducers: {
    updateTextInterviewDetails: (state, action) => {
      state.textInterviewDetails = action.payload
    },
    updatePracticeCountSavedQuestions: (state, action) => {
      const { questionId } = action.payload
      state.allSavedQuestions = state.allSavedQuestions.map((r) => {
        if (r._id == questionId) return { ...r, noOfPractices: r.noOfPractices + 1 }
        else return { ...r }
      })
    },
    setValueByKeySavedQuestions: (state, action) => {
      action.payload.forEach(el => {
        const key = el.key
        const value = el.value
        state[key] = value
      })
    }
  },

  extraReducers: {
    [getSavedQuestions.pending]: state => {
      state.showGetSavedQuestionLoader = true
    },
    [getSavedQuestions.fulfilled]: (state, action) => {
      state.showGetSavedQuestionLoader = false
      state.allSavedQuestions = action.payload.savedQuestions
    },
    [getSavedQuestions.rejected]: state => {
      state.showGetSavedQuestionLoader = false
    },
    [saveHighlight.pending]: state => {
      state.showHighlightLoader = true
    },
    [saveHighlight.fulfilled]: (state, action) => {
      state.showHighlightLoader = false
      const { success } = action.payload.response

      const { questionId,
        answerHighlightArr,
        followUpAnswerHighlightArr } = action.payload.questionInfo
      if (!success) return
      if (answerHighlightArr) {
        state.allSavedQuestions = state.allSavedQuestions.map((r) => {
          if (r._id == questionId) return { ...r, answerHighlightArr }
          else return { ...r }
        })
      } else if (followUpAnswerHighlightArr) {
        state.allSavedQuestions = state.allSavedQuestions.map((r) => {
          if (r._id == questionId) return {
            ...r, followupQnas: r.followupQnas.map(el => {
              return { ...el, followUpAnswerHighlightArr }
            })
          }
          else return { ...r }
        })
      }
    },
    [saveHighlight.rejected]: state => {
      state.showHighlightLoader = false
    },
    [getHowToApproach.pending]: state => {
      state.showHowToApproachLoader = true
    },
    [getHowToApproach.fulfilled]: (state, action) => {
      const { success, payload } = action.payload.response
      const { roundId, questionId, type } = action.payload.questionInfo
      state.showHowToApproachLoader = false
      if (success) {
        state.allSavedQuestions = state.allSavedQuestions.map((q) => {
          if (q._id == questionId){
            if (type === 'main') {
              return {
                ...q, howToApproach: payload.howToApproach
              }
            } else {
              return {
                ...q, followupQnas: [
                  ...q.followupQnas.slice(0, 0),
                  {
                    ...q.followupQnas[0],
                    howToApproach: payload.howToApproach,
                  },
                  ...q.followupQnas.slice(1),
                ]
              }
            }
          }
          else return { ...q }
        })
        state.howToApproachContent = payload.howToApproach
      }
    },
    [getHowToApproach.rejected]: state => {
      state.showHowToApproachLoader = false
    },
  }
})

export const { setValueByKeySavedQuestions, updatePracticeCountSavedQuestions } = savedQuestionsSlice.actions

export default savedQuestionsSlice.reducer